/*jshint esversion: 6 */
export default (function(config) {
    let elParent = config.selectorParent;
    let elChild = config.selectorChild;

    let acc = document.getElementsByClassName(elParent);
    let i;

    let deactivateAll = function () {
        let parents = document.getElementsByClassName(elParent);
        for (let i = 0; i < parents.length; i++) {
            let parent = parents[i];
            parent.classList.remove("active");
            let panel = parent.nextElementSibling;
            panel.style.display = "none";
        }
    }

    function deactivateOtherParents(elParent, thisParent) {
        let elements = document.getElementsByClassName(elParent);
        for (let i = 0; i < elements.length; i++) {
            let element = elements[i];
            if (thisParent != element) {
                element.classList.remove("active");
            }
        }
    }

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {

            deactivateOtherParents(elParent, this);

            let children = document.getElementsByClassName(elChild);

            let child;
            for(child = 0; child < children.length; child++){
                children[child].style.display = "none";
            }

            this.classList.toggle("active");

            let panel = this.nextElementSibling;
            if (panel.style.display === "block") {
                panel.style.display = "none";
            } else {
                panel.style.display = "block";
            }

            if(!this.classList.contains('active')) {
                panel.style.display = "none";
            }
        });
    }

    return {
        deactivateAll: deactivateAll
    }
});